import { Col, Row } from 'antd';
import { getCategoryName } from 'Pages/Home/Helper/Formatter';
import { useFetchCollectionData } from 'Pages/Home/Hooks/useFetchCollectionData';
import React, { useMemo } from 'react';
import KickImage from 'Reuseables/KickImage';
import { useHistory } from 'react-router';
import Card from '../../Atoms/Card/Card';
import Section from '../../Molecules/Section';
import Styles from './CardCollectionSection.module.scss';
import { TCardCollectionSectionProps } from './definitions';

const CardCollectionSection: React.FC<TCardCollectionSectionProps> = ({
  className,
  slug,
  category,
  rowClassName,
  productRowClassname,
  title,
  subtitle,
  actionText = 'View All',
  isPreverified,
  userCurrency
}) => {
  const history = useHistory();
  const { data: productData } = useFetchCollectionData(
    category,
    slug,
    16,
    isPreverified,
  );
  const wrapperClassName = useMemo(() => {
    return className ? className : Styles['wrapper'];
  }, [className]);

  const onViewAll = () => {
    window.open(
      `/${getCategoryName(category)}/collection/${slug}${
        isPreverified
          ? '?sneakers_condition=express_shipping&sort_by=price_asc&express_shipping=true'
          : ''
      }`,
      '_blank',
    );
  };

  const renderItems = useMemo(() => {
    if (!productData?.length) {
      return null;
    }

    return productData.map((item, index) => {
      const onClickProduct = () => {
        if (isPreverified) {
          history.push(
            `/${getCategoryName(item.category)}/${item.brand}/${
              item.slug
            }?collection=${slug}&express_shipping=true&from=home`,
          );
          return;
        }
        history.push(
          `/${getCategoryName(item.category)}/${item.brand}/${item.slug}?from=home`,
        );
      };
      return (
        <Col key={`holy-grail-card-${index}`} span={6}>
          <Card.ProductHorizontal
            title={item.title}
            price={item.price}
            image={item.image}
            onClick={onClickProduct}
            isOnlyKickPoint={item.isOnlyKickPoint}
            userCurrency={userCurrency}
          />
        </Col>
      );
    });
  }, [productData]);

  if (!productData || !productData?.length) {
    return <div />;
  }

  return (
    <div className={wrapperClassName}>
      <Section
        title={title}
        subTitle={subtitle || ''}
        actionText={actionText}
        withBorder={true}
        rowClassname={rowClassName}
        onAction={onViewAll}
        productRowClassname={productRowClassname}
        withPaddingTitle={document.body.clientWidth <= 768}
      >
        <Row style={{ width: '100%' }}>{renderItems}</Row>
      </Section>
    </div>
  );
};

export default CardCollectionSection;
